import CashAccountSearchResponseBase from './base/CashAccountSearchResponseBase';

/**
 * @class CashAccountSearchResponse
 * @extends CashAccountSearchResponseBase
 */
class CashAccountSearchResponse extends CashAccountSearchResponseBase {

}

export default CashAccountSearchResponse;
